import { GENERIC_LOAN_DISCLAIMER, JYSKE_BANK_LOAN_DISCLAIMER, NORDEA_LOAN_DISCLAIMER } from '~src/constants';
import { CustomerFinancingProvider } from '~src/model';
import { BookingFormVariant } from '~src/components/BookingForm';

export const getDisclaimer = (financingProvider?: CustomerFinancingProvider) => {
  switch (financingProvider) {
    case 'jyskebank': {
      return JYSKE_BANK_LOAN_DISCLAIMER;
    }
    case 'nordea': {
      return NORDEA_LOAN_DISCLAIMER;
    }
    default: {
      return GENERIC_LOAN_DISCLAIMER;
    }
  }
};

export const getBookingFormVariant = (): BookingFormVariant => {
  if (typeof window === 'undefined') {
    return 'default';
  }

  return new URLSearchParams(window.location.search).get('formVariant') === 'offer' ? 'offerIdentity' : 'default';
};
